<template>
  <div id="app">
          <router-view></router-view>
</div>
</template>
<script>

export default {
  name: '',
  data () {
    return {

    }
  }

}
</script>
<style>
html,
body {  
  /* height: 100%;
  height: calc(100vh - 40px) !important;
  overflow-x: hidden; */
}
body{-webkit-touch-callout: none ;}
*{
    padding: 0;
    margin: 0;
  }
</style>
